(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aeropal-color-preview-v2"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ap-configurator]').forEach(function (section) {
    const image = section.querySelector('[data-ap-preview-image]');
    const imageLabel = section.querySelector('[data-ap-combination-label]');
    const selection = section.querySelector('[data-ap-selection]');
    const bodyButtons = Array.from(section.querySelectorAll('[data-ap-body]'));
    const detailButtons = Array.from(section.querySelectorAll('[data-ap-detail]'));
    const records = new Map();

    section.querySelectorAll('[data-ap-combo]').forEach(function (record) {
      records.set(record.dataset.apCombo, {
        image: record.dataset.image,
        alt: record.dataset.alt
      });
    });

    let body = 'black';
    let detail = 'white';

    function labelFor(buttons, value) {
      const button = buttons.find(function (item) {
        return item.dataset.apBody === value || item.dataset.apDetail === value;
      });
      return button ? button.dataset.label : value;
    }

    function setSelected(buttons, activeButton) {
      buttons.forEach(function (button) {
        const selected = button === activeButton;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
    }

    function updatePreview() {
      const key = body + '-' + detail;
      const bodyLabel = labelFor(bodyButtons, body);
      const detailLabel = labelFor(detailButtons, detail);
      const combination = bodyLabel + ' / ' + detailLabel.toLowerCase();
      const record = records.get(key);
      const nextImage = record && record.image ? record.image : section.dataset.defaultImage;

      image.classList.add('is-changing');
      window.setTimeout(function () {
        image.src = nextImage;
        image.alt = record && record.alt ? record.alt : combination;
        image.classList.remove('is-changing');
      }, 140);

      imageLabel.textContent = combination;
      selection.textContent = combination;
    }

    bodyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        body = button.dataset.apBody;
        setSelected(bodyButtons, button);
        updatePreview();
      });
    });

    detailButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        detail = button.dataset.apDetail;
        setSelected(detailButtons, button);
        updatePreview();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aeropal-design-v2"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ap-design]').forEach(function (section) {
    section.classList.add('is-motion-ready');

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('is-visible');
            observer.disconnect();
          }
        });
      }, { threshold: 0.16 });
      observer.observe(section);
    } else {
      section.classList.add('is-visible');
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aeropal-engineering-v2"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ap-engineering]').forEach(function (section) {
    section.classList.add('is-motion-ready');

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('is-visible');
            observer.disconnect();
          }
        });
      }, { threshold: 0.1 });
      observer.observe(section);
    } else {
      section.classList.add('is-visible');
    }

    const video = section.querySelector('video');
    const control = section.querySelector('[data-ap-engineering-control]');
    const label = section.querySelector('[data-ap-engineering-label]');
    const icon = section.querySelector('[data-ap-engineering-icon]');
    if (!video || !control || !label || !icon) return;

    control.addEventListener('click', function () {
      const pauseLabel = control.dataset.apPauseLabel;
      const playLabel = control.dataset.apPlayLabel;
      if (video.paused) {
        video.play();
        control.setAttribute('aria-pressed', 'false');
        control.setAttribute('aria-label', pauseLabel);
        label.textContent = pauseLabel;
        icon.textContent = 'Ⅱ';
      } else {
        video.pause();
        control.setAttribute('aria-pressed', 'true');
        control.setAttribute('aria-label', playLabel);
        label.textContent = playLabel;
        icon.textContent = '▶';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aeropal-header-v2"] && !Shopify.designMode) return;
  try {
    
  if (!window.__apCartRequestWatcherInstalled) {
    window.__apCartRequestWatcherInstalled = true;

    function isCartMutationUrl(value) {
      let url = '';
      if (typeof value === 'string') url = value;
      else if (value && typeof value.url === 'string') url = value.url;
      return /\/cart\/(add|change|update|clear)(\.js)?([?#]|$)/.test(url);
    }

    function announceCartMutation() {
      document.dispatchEvent(new CustomEvent('ap:cart-mutated'));
    }

    const nativeFetch = window.fetch;
    if (nativeFetch) {
      window.fetch = function () {
        const request = arguments[0];
        const isCartMutation = isCartMutationUrl(request);
        return nativeFetch.apply(this, arguments).then(function (response) {
          if (isCartMutation && response.ok) announceCartMutation();
          return response;
        });
      };
    }

    const nativeXhrOpen = XMLHttpRequest.prototype.open;
    const nativeXhrSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__apIsCartMutation = isCartMutationUrl(url);
      return nativeXhrOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__apIsCartMutation) {
        this.addEventListener('loadend', function () {
          if (this.status >= 200 && this.status < 400) announceCartMutation();
        }, { once: true });
      }
      return nativeXhrSend.apply(this, arguments);
    };
  }

  document.querySelectorAll('[data-ap-header]').forEach(function (header) {
    const menu = header.querySelector('.ap-header__menu');
    const count = header.querySelector('[data-ap-cart-count]');
    const cartArea = header.querySelector('[data-ap-cart-area]');
    const previewBody = header.querySelector('[data-ap-cart-preview-body]');
    let cartLoaded = false;
    if (menu) {
      menu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () { menu.removeAttribute('open'); });
      });
      document.addEventListener('click', function (event) {
        if (menu.open && !menu.contains(event.target)) menu.removeAttribute('open');
      });
    }
    function formatMoney(amount, currency) {
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency: currency || 'DKK' }).format(amount / 100);
    }
    function renderCart(cart) {
      if (count) {
        count.textContent = cart.item_count;
        count.classList.toggle('is-empty', cart.item_count === 0);
      }
      if (!previewBody) return;
      previewBody.replaceChildren();
      if (!cart.item_count) {
        const empty = document.createElement('p');
        empty.className = 'ap-header__cart-preview-empty';
        empty.textContent = 'Din kurv er tom.';
        previewBody.appendChild(empty);
        return;
      }
      const list = document.createElement('ul');
      list.className = 'ap-header__cart-preview-list';
      cart.items.slice(0, 3).forEach(function (item) {
        const row = document.createElement('li');
        row.className = 'ap-header__cart-preview-item';
        if (item.image) {
          const image = document.createElement('img');
          image.className = 'ap-header__cart-preview-image';
          image.src = item.image;
          image.alt = '';
          image.width = 58;
          image.height = 58;
          row.appendChild(image);
        } else {
          const imageFallback = document.createElement('span');
          imageFallback.className = 'ap-header__cart-preview-image';
          row.appendChild(imageFallback);
        }
        const copy = document.createElement('div');
        copy.className = 'ap-header__cart-preview-copy';
        const name = document.createElement('p');
        name.className = 'ap-header__cart-preview-name';
        name.textContent = item.product_title;
        const meta = document.createElement('p');
        meta.className = 'ap-header__cart-preview-meta';
        meta.textContent = (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title + ' · ' : '') + 'Antal: ' + item.quantity;
        copy.append(name, meta);
        const price = document.createElement('span');
        price.className = 'ap-header__cart-preview-price';
        price.textContent = formatMoney(item.final_line_price, cart.currency);
        row.append(copy, price);
        list.appendChild(row);
      });
      previewBody.appendChild(list);
      const footer = document.createElement('div');
      footer.className = 'ap-header__cart-preview-footer';
      const total = document.createElement('div');
      total.className = 'ap-header__cart-preview-total';
      const totalLabel = document.createElement('span');
      totalLabel.textContent = 'Subtotal';
      const totalPrice = document.createElement('strong');
      totalPrice.textContent = formatMoney(cart.total_price, cart.currency);
      total.append(totalLabel, totalPrice);
      const link = document.createElement('a');
      link.className = 'ap-header__cart-preview-link';
      link.href = '/cart';
      link.textContent = 'Se kurven';
      footer.append(total, link);
      previewBody.appendChild(footer);
    }
    function refreshCart() {
      if (!count && !previewBody) return;
      return fetch('/cart.js?t=' + Date.now(), {
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          cartLoaded = true;
          renderCart(cart);
        })
        .catch(function () {
          if (!previewBody) return;
          const error = document.createElement('p');
          error.className = 'ap-header__cart-preview-empty';
          error.textContent = 'Kurven kunne ikke indlæses.';
          previewBody.replaceChildren(error);
        });
    }
    function scheduleCartRefresh() {
      [180, 500, 950, 1600, 2600].forEach(function (delay) {
        window.setTimeout(refreshCart, delay);
      });
    }
    if (cartArea) {
      cartArea.addEventListener('mouseenter', function () { if (!cartLoaded) refreshCart(); }, { once: true });
      cartArea.addEventListener('focusin', function () { if (!cartLoaded) refreshCart(); }, { once: true });
    }
    ['cart:updated', 'cart:refresh', 'cart:change', 'product:added'].forEach(function (name) {
      document.addEventListener(name, scheduleCartRefresh);
    });
    document.addEventListener('ap:cart-mutated', scheduleCartRefresh);
    document.addEventListener('submit', function (event) {
      if (event.target.matches('form[action*="/cart"]')) scheduleCartRefresh();
    }, true);
    document.addEventListener('change', function (event) {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (target.matches('input[name^="updates"], select[name^="updates"]') || target.closest('cart-items, [data-cart-items], .cart-items')) {
        scheduleCartRefresh();
      }
    }, true);
    document.addEventListener('click', function (event) {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const cartControl = target.closest('a[href*="/cart/change"], cart-remove-button, [data-cart-remove], quantity-input button, .quantity__button, button[name="plus"], button[name="minus"], button[name="update"]');
      if (cartControl) scheduleCartRefresh();
    }, true);
    if (/\/cart\/?$/.test(window.location.pathname)) {
      const cartContent = document.querySelector('main form[action*="/cart"], main cart-items, main [data-cart-items], main .cart-items, main');
      if (cartContent) {
        let cartMutationTimer;
        const cartObserver = new MutationObserver(function () {
          window.clearTimeout(cartMutationTimer);
          cartMutationTimer = window.setTimeout(refreshCart, 120);
        });
        cartObserver.observe(cartContent, { childList: true, subtree: true, characterData: true });
      }
    }
    window.addEventListener('pageshow', refreshCart);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refreshCart();
    });
    refreshCart();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aeropal-hero-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function startHeroVideo(root) {
      const video = root.querySelector('.ap-hero__video');
      if (!video || video.dataset.apAutoplayReady === 'true') return;

      video.dataset.apAutoplayReady = 'true';
      video.autoplay = true;
      video.loop = true;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.controls = false;
      video.setAttribute('autoplay', '');
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('disablepictureinpicture', '');
      video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');

      function play() {
        video.muted = true;
        const promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(function () {});
      }

      video.addEventListener('loadedmetadata', play);
      video.addEventListener('loadeddata', play);
      video.addEventListener('canplay', play);
      window.addEventListener('pageshow', play);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) play();
      });

      [0, 150, 500, 1200, 2500].forEach(function (delay) {
        window.setTimeout(play, delay);
      });

      document.addEventListener('touchstart', play, { once: true, passive: true });
      document.addEventListener('click', play, { once: true });
      video.load();
      play();
    }

    function initialiseHeroVideos(scope) {
      const container = scope || document;
      container.querySelectorAll('.ap-hero').forEach(startHeroVideo);
    }

    initialiseHeroVideos(document);
    document.addEventListener('DOMContentLoaded', function () { initialiseHeroVideos(document); });
    document.addEventListener('shopify:section:load', function (event) { initialiseHeroVideos(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
